
























































import Vue from "vue";
export default Vue.extend({
  props: {
    hasClose: {
      type: Boolean,
      default: true
    }
  }
});
